/* unplugin-vue-components disabled */import script from "./CategoryManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryManager.vue?vue&type=script&setup=true&lang=js"

import "./CategoryManager.vue?vue&type=style&index=0&id=5a8d83f1&lang=css"

const __exports__ = script;

export default __exports__